import SvgIcon from '@components/SvgIcon'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { mobileCSS, tabletCSS, desktopCSS } from '@measures/responsive'
import { useFullScreenGallery } from '@hooks/useFullScreenGallery'

const Container = styled.div<{ isFullScreen: boolean }>`
  ${({
    theme: {
      measures: {
        content: {
          paddingLeft: contentPaddingLeft,
          paddingTablet: contentPaddingTablet,
        },
      },
      colors: { white },
    },
    isFullScreen,
  }) => {
    return css`
      display: flex;
      flex-direction: row;
      padding-top: 23px;

      /** inline css */
      ${desktopCSS(
        css`
          padding: 12px 0 40px ${contentPaddingLeft};
          z-index: 1;
        `
      )}
      ${tabletCSS(css`
        padding: 12px 0 40px ${contentPaddingTablet};
        z-index: 1;
      `)}
      ${mobileCSS(css`
        z-index: 1;
        position: absolute;
        margin: -43px 0 0 7px;

        ${isFullScreen &&
        css`
          position: relative;
          color: ${white};
          width: 20vw;
          padding: 0px;
          margin: 0px;
        `}
      `)}
    `
  }}
`

const Label = styled.span<{ isFullScreen: boolean }>`
  ${({
    theme: {
      colors: {
        white,
        grey: { grey_100 },
      },
    },
  }) => css`
    margin-left: 10px;
    font-size: 12px;
    color: ${grey_100};

    line-height: 1.5;

    ${mobileCSS(css`
      color: ${white};
      text-shadow: 0 0 5px ${grey_100}, 0 0 8px ${grey_100},
        0 0 10px ${grey_100};
    `)}
  `}
`

interface CounterProps {
  children: string
}

const Counter: FunctionComponent<CounterProps> = ({ children }) => {
  const { isFullScreen } = useFullScreenGallery()

  return (
    <Container isFullScreen={isFullScreen}>
      <SvgIcon iconName="gallery-photo" size={21} />
      <Label isFullScreen={isFullScreen}>{children}</Label>
    </Container>
  )
}

export default Counter
